module.exports = __webpack_public_path__ + "static/bg-happy_hockey-a4d134f36b40a06be34346c138804e3f.jpg";